import FormHelpers from '../util/form';
import {
    newModalFromString
} from '../components/modal';
import Plugins from '../util/plugins';
import RegistrationHelper from './registrationHelper';

/**
 * Toggle loyalty popover on form submit.
 * @param {boolean} state - true if popover should be shown, otherwise false
 */
const toggleLoyaltyPopover = function (state) {
    $('.policy-promotion-loyalty').find('.slider').toggleClass('loyalty-highlight', state);

    if (state) {
        $('.popover-loyalty-member-tez').fadeIn('fast', function () {
            $(this).removeClass('hidden');
        });
    } else {
        $('.popover-loyalty-member-tez').fadeOut('fast', function () {
            $(this).addClass('hidden');
        });
    }
};

/**
 * Show alert if loyalty flag is off.
 */
const checkLoyaltyFlag = function () {
    var button = $('.button-register-final');

    if ((RegistrationHelper.isRegistrationModalFlow() && $('.registrationModal-box').attr('data-registration-modal-stage') === 'phone') || (RegistrationHelper.isRegistrationLoyaltyModalFlow() && $('.registrationModal-box').attr('data-registration-modal-stage') === 'registration')) {
        return true;
    }

    if (!button.length || $('.policy-promotion-loyalty').hasClass('hidden') || $('.policy-promotion-loyalty').length === 0) {
        return true;
    }

    var loyaltyFlagState = button.data('loyalty-check');
    if (!loyaltyFlagState) {
        button.data('loyalty-check', true);
    }
    toggleLoyaltyPopover(!loyaltyFlagState);

    return loyaltyFlagState;
};

const toggleRememberPopover = function (fromLayer, state) {
    const location = fromLayer ? '.layer-login-modal ' : '.login-tabs ';
    if (state) {
        $(location + '.popover-remember-me').fadeIn('fast', function () {
            $(this).removeClass('hidden');
        });
    } else {
        $(location + '.popover-remember-me').fadeOut('fast', function () {
            $(this).addClass('hidden');
        });
    }
};

/**
 * Show alert if Remember flag is off.
 */
const checkRememberFlag = function (fromLayer) {
    var button = $('#rememberMe');
    if (fromLayer) {
        button = $('.layer-login-modal #rememberMeTwo');
    }

    if (!button.length || button.is(':checked')) {
        return true;
    }

    var rememberMeFlagState = button.data('rememberMe-check');
    if (!rememberMeFlagState) {
        button.data('rememberMe-check', true);
    }

    toggleRememberPopover(fromLayer, !rememberMeFlagState);

    return rememberMeFlagState;
};

const initNewsletterAnalyticsBrands = function () {
    if (!window.newsletterPreferenceBrands) {
        window.newsletterPreferenceBrands = [];
    }
};

/**
 * Format date based on given pattern.
 */
export const formatDate = function (date, formatPattern) {
    if (formatPattern === 'dd-mm-yyyy') {
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
    } else if (formatPattern === 'mm-dd-yyyy') {
        return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' + date.getFullYear();
    } else if (formatPattern === 'yyyy年mm月dd日') {
        var dateParsed = (date.getFullYear() + '年' + ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日');
        return dateParsed;
    }
};

class Customer {
    constructor () {
        this.accountLogin = 'form.login';
        this.accountRegister = 'form.registration';
        this.resetPassword = '.reset-password-form';
        this.checkoutLogin = 'form.login';
        this.checkoutRegister = 'form.checkout-registration';
        this.editProfile = 'form.edit-profile-form';
        this.editPassword = 'form.change-password-form';
    }

    fireGenericAnalyticsErrorEvent (type, step, errorMsg) {
        $('body').trigger('customer:account_error', {
            'type': type,
            'step': step,
            'errorMsg': errorMsg
        });
    }

    fireSpecificAnalyticsErrorEvent (mainType, subType, error, rememberMe, sessionExpired, regFlowPosition) {
        $('body').trigger('customer:' + mainType, {
            'type': subType,
            'regFlowPosition': regFlowPosition,
            'data': {
                'error': [error],
                'rememberMe': rememberMe,
                'sessionExpired': sessionExpired
            }
        });
    }

    fireSpecificEventModeAnalyticsErrorEvent (mainType, subType, error, eventMode, rememberMe, sessionExpired) {
        $('body').trigger('customer:' + mainType, {
            'type': subType,
            'eventMode': eventMode,
            'data': {
                'error': [error],
                'rememberMe': rememberMe,
                'sessionExpired': sessionExpired
            }
        });
    }

    datePicker () {
        let formatPattern = $('.datepickerTriggerElement').data('date-format-pattern');

        $('.datepickerTriggerElement').fdatepicker({
            format: formatPattern,
            disableDblClickSelection: true,
            leftArrow: '<<',
            rightArrow: '>>',
            closeIcon: 'X',
            closeButton: false
        }).on('changeDate', function (ev) {
            let date = new Date(ev.date.valueOf() + ev.date.getTimezoneOffset() * 60000);
            var datestring = formatDate(date, formatPattern);
            $('#dpReg').val(datestring);
            $('.datepickerTriggerElement').data('date', datestring);
        });

        if ($('#dpReg').val() !== '') {
            let formattedDate = $('#dpReg').val();
            $('.datepickerTriggerElement').data('date', formattedDate);
        }
    }

    toggleVisiblePassword () {
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            $('body').on('touchstart', '.toggle-password', function (e) {
                const password = $(this).closest('.form-group').find('.pwd-input');
                const type = password.attr('type') === 'password' ? 'text' : 'password';
                password.attr('type', type);
                $(this).toggleClass('pwd-icon-visible');
                e.stopImmediatePropagation();
            });
        } else {
            $('body').on('click', '.toggle-password', function (e) {
                const password = $(this).closest('.form-group').find('.pwd-input');
                const type = password.attr('type') === 'password' ? 'text' : 'password';
                password.attr('type', type);
                $(this).toggleClass('pwd-icon-visible');
                e.stopImmediatePropagation();
            });
        }
    }

    checkPasswordValidation () {
        const pwd = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#\$%\^\&*\)\(+=._-]{8,}$/;
        $('.password-tip').hide();
        $('#registration-form-password, #newPassword').keyup(function () {
            (!this.value.match(pwd) && $(this).val().length !== 0) ? $('.password-tip').show() : $('.password-tip').hide();
        });
    }

    slickThankYouPage () {
        $('.category-grid').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: false,
            infinite: true,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                    arrows: true,
                    dots: false
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                    arrows: false,
                    centerMode: true,
                    dots: false
                }
            }]
        });
    }

    accountProfile () {
        // Remove "&jut=t" URL parameter (required if user reloads page)
        if (window.location.href.indexOf('ju') > -1) {
            var cleanUri = location.protocol + '//' + location.host + location.pathname;
            window.history.replaceState({}, document.title, cleanUri);
        }

        var _self = this;

        // Handle both profile and password forms in the same way on different container
        $('body').on('click', '.js-edit-profile, .js-edit-password, .js-edit-email', function (e) {
            e.preventDefault();

            var url = $(e.currentTarget).data('url');
            if ($(e.currentTarget).hasClass('js-edit-password-persistent')) {
                url += (url.indexOf('?') !== -1 ? '&' : '?') + 'changePassword=true';
            }
            const $container = $(e.currentTarget).closest('.profile-container');

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                success: function (data) {
                    $.spinner().stop();

                    $container.find('.current-data').slideUp('fast', function () {
                        $(this).toggleClass('hidden');
                    });
                    $container.find('.update-data .card-body').html(data);
                    $container.find('.update-data').slideDown('fast', function () {
                        $(this).toggleClass('hidden');
                    });

                    // Chosen select
                    if (Foundation.MediaQuery.atLeast('medium')) {
                        $('select.select-chosen').chosen({disable_search: true});
                    }

                    Plugins.init();
                    _self.datePicker();
                    // Chosen select
                    if (Foundation.MediaQuery.atLeast('medium')) {
                        $('select.select-chosen').chosen({disable_search: true});
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        // On cancel reset AJAX container
        $('body').on('click', '.js-cancel-edit-profile, .js-cancel-edit-password, .js-cancel-edit-email', function (e) {
            e.preventDefault();

            const $container = $(e.currentTarget).closest('.profile-container');

            $container.find('.update-data').slideUp('fast', function () {
                $(this).toggleClass('hidden');
                $(this).find('.card-body').html('');
            });
            $container.find('.current-data').slideDown('fast', function () {
                $(this).toggleClass('hidden');
            });
        });
    }

    accountLoginForm (fromLayer = false, $myAccountEditButton) {
        const _self = this;
        $('form.login').ready(function () {
            if (window.location.href.indexOf('tab.reg') >= 0 || window.location.href.indexOf('tab%2ereg') >= 0) {
                $('#tab-login-cell, .js-link-access').removeClass('current');
                $('#tab-registration-cell, .js-link-register').addClass('current');
            }
        });

        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            if (!checkRememberFlag(fromLayer)) {
                return;
            } else {
                toggleRememberPopover(false);
            }
            var url = form.attr('action');
            if ($('.js-persistent-layer').length) {
                url += '&isPersistent=true';
            }
            $.spinner().start();

            var regFlowPosition;
            if (form.is('#unified-login-form')) {
                regFlowPosition = $('.js-unified-page-wrapper').length ? 'landing_page' : 'modal';
            }

            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.socialCustomer) {
                            socialLoginOpenForgotPasswordModal(data.email);
                        } else {
                            FormHelpers.init(form, data);
                            $('form.login').trigger('login:error', data);
                            var loginErrorType = (data && data.alreadyRegistered) ? 'account_created_but_not_activated_yet' : 'wrong_email_or_wrong_password';
                            _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', loginErrorType);
                            _self.fireSpecificAnalyticsErrorEvent('login', 'login', loginErrorType, data.rememberMe, false, regFlowPosition);
                        }
                    } else {
                        $('form.login').trigger('login:success', data);
                        $('body').trigger('customer:login', {
                            'type': 'login',
                            'data': data,
                            'regFlowPosition': regFlowPosition
                        });
                        var isCountryExcludedFromImplicitLoyalty = $('#isCountryExcludedFromImplicitLoyalty').val();
                        if (isCountryExcludedFromImplicitLoyalty !== 'true' && $myAccountEditButton && $myAccountEditButton.data('section')) {
                            $('[data-section="profile"]').removeClass('editProfilePersistent').addClass('js-edit-profile');
                            $('[data-section="email"]').removeClass('editProfilePersistent').addClass('js-edit-email');
                            $('[data-section="password"]').removeClass('editProfilePersistent').addClass('js-edit-password js-edit-password-persistent');
                            $('body').trigger('persistentLogin:standardCustomer');
                            let dataSection = $myAccountEditButton.data('section');
                            if (dataSection === 'profile') {
                                $('.js-edit-profile').trigger('click');
                            } else if (dataSection === 'email') {
                                $('.js-edit-email').trigger('click');
                            } else if (dataSection === 'password') {
                                $('.js-edit-password').trigger('click');
                            } else {
                                location.reload();
                            }
                        } else if (fromLayer) {
                            location.reload();
                        } else if (!RegistrationHelper.isUserLoyaltyForThisBrand(data.response.customerFidelitySubscriptions) && RegistrationHelper.isLoyaltyAvailable()) {
                            $('.js-unified-modal-loyalty-registration').val('user-is-logged');
                            $('.js-unified-modal-loyalty-registration').first().trigger('click');
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (data) {
                    _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', 'unknown_error');
                    $('body').trigger('customer:login', {
                        'type': 'login',
                        'data': {
                            'error': [ 'unknown_error' ]
                        },
                        'regFlowPosition': regFlowPosition
                    });

                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });

        $('.login-pwd .remember-me-container .rememberme-wrapper #rememberMeTwo').on('click', function () {
            $('body').trigger('customer:persistentTooltip');
        });

        function enableLoginAnalyticsObserver () {
            let targetLoginNode = $('form.login:visible')[0];
            if (targetLoginNode) {
                let config = { attributes: true, childList: true, subtree: true };
                let callback = function (mutationsList, observer) {
                    let inputSet = new Set();
                    let genericEventAlreadyFired = false;
                    for (let index = 0; index < mutationsList.length; index++) {
                        let mutation = mutationsList[index];
                        if (mutation.type === 'attributes' &&
                            mutation.target.nodeName === 'INPUT' &&
                            mutation.attributeName === 'class' &&
                            mutation.target.classList.contains('is-invalid-input')) {
                            if (!inputSet.has(mutation.target.id)) {
                                let errorMsg = 'unknown_error';
                                if (mutation.target.id.includes('email')) {
                                    errorMsg = mutation.target.value ? 'email_already_registered_in_existing_account' : 'empty_field_or_invalid_email';
                                } else if (mutation.target.id.includes('password')) {
                                    errorMsg = mutation.target.value ? 'wrong_email_or_wrong_password' : 'empty_password';
                                } else {
                                    errorMsg = 'unknown_error';
                                }
                                let rememberMe = false;
                                let sessionExpired = false;
                                if ($('#rememberMe, .layer-login-modal #rememberMeTwo').length && $('#rememberMe,.layer-login-modal #rememberMeTwo').is(':checked')) {
                                    rememberMe = true;
                                }
                                if ($('.js-persistent-layer').length) {
                                    sessionExpired = true;
                                }
                                _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificAnalyticsErrorEvent('login', 'login', errorMsg, rememberMe, sessionExpired);
                                    genericEventAlreadyFired = true;
                                }

                                inputSet.add(mutation.target.id);
                            }
                        }
                    }
                    observer.disconnect();
                };

                let observer = new MutationObserver(callback);
                observer.observe(targetLoginNode, config);
            }
        }

        if ($('form.login').length > 0) {
            var submitButtonAnalytics = $('form.login').find('button[type=submit]:visible');
            if(submitButtonAnalytics.length === 0){
                submitButtonAnalytics = $('form.login:first').find('button[type=submit]');
            }
            submitButtonAnalytics.on('click', function (e) {
                enableLoginAnalyticsObserver();
            });
        }

        function socialLoginOpenForgotPasswordModal (email) {
            $('body').trigger('socialLoginError:standardCustomer');
            const htmlContent = $('#requestPasswordResetModal').clone().html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['resetPwdModal', 'layer-password-modal']);
            $(modal.modalBox).addClass('new-footer-form-style rightModalAttribute');
            Plugins.init();
            modal.open();
            _self.resetPasswordForm();
            $(modal.modalBox).find('.request-password-title').addClass('hidden');
            $(modal.modalBox).find('.social-request-password-title').removeClass('hidden');
            if (Foundation.MediaQuery.atLeast('large')) {
                var socialTitle = $(modal.modalBox).find('.social-request-password-title.show-for-large').data('title');
            } else {
                var socialTitle = $(modal.modalBox).find('.social-request-password-title.hide-for-large').data('title-mobile');
            }
            $(modal.modalBox).find('.social-request-password-title').text(socialTitle);
            $(modal.modalBox).find('.request-password-body-description').addClass('hidden');
            $(modal.modalBox).find('.social-request-password-body-description').removeClass('hidden');
            $(modal.modalBox).find('#reset-password-email').val(email);
            $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });
            $(modal.modalBox).on('click', '.back-to-login', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });
        }
    }

    loginAndAssociateOrderWithLoyaltyCustomer () {
        const _self = this;
        $('form.loginAndAssociateOrder').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();

            $('form.loginAndAssociateOrder').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                        $('loginAndAssociateOrder.login').trigger('login:error', data);
                        $('#login-form-password').val('');
                        _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', 'wrong_email_or_wrong_password');
                        _self.fireSpecificAnalyticsErrorEvent('login', 'login', 'wrong_email_or_wrong_password');
                    } else {
                        // order association request
                        var associationForm = $('form.orderAssociation');
                        var url = associationForm.attr('action');
                        $('body').trigger('customer:login', {
                            'type': 'login',
                            'data': data
                        });
                        $.ajax({
                            url: url,
                            type: "post",
                            dataType: "json",
                            data: associationForm.serialize(),
                            success: function (data) {
                                if (data.success) {
                                    location.href = data.redirectUrl;
                                } else {
                                    // order can't be associated
                                    $('#login').prop('disabled',true);
                                    $('.login-form-error').addClass('hidden');
                                    $('#orderAssociationError').removeClass('hidden');
                                }
                            },
                            error: function (data) {
                                $('#login').prop('disabled',true);
                                $('.login-form-error').addClass('hidden');
                                $('#orderAssociationError').removeClass('hidden');
                                $('loginAndAssociateOrder.login').trigger('login:error', data);
                            }
                        });
                    }
                },
                error: function (data) {
                    $('body').trigger('customer:login', {
                        'type': 'login',
                        'data': ['unknown_error']
                    });
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('loginAndAssociateOrder.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });

        function enableLoginAndAssociateAnalyticsObserver () {
            let targetLoginNode = $('form.loginAndAssociateOrder').get(0);
            if (targetLoginNode) {
                let config = { attributes: true, childList: true, subtree: true };
                let callback = function (mutationsList, observer) {
                    let inputSet = new Set();
                    let genericEventAlreadyFired = false;
                    for (let index = 0; index < mutationsList.length; index++) {
                        let mutation = mutationsList[index];
                        if (mutation.type === 'attributes' &&
                            mutation.target.nodeName === 'INPUT' &&
                            mutation.attributeName === 'class' &&
                            mutation.target.classList.contains('is-invalid-input')) {
                            if (!inputSet.has(mutation.target.id)) {
                                let errorMsg = 'unknown_error';
                                if (mutation.target.id.includes('email')) {
                                    errorMsg = mutation.target.value ? 'email_already_registered_in_existing_account' : 'empty_field_or_invalid_email';
                                } else if (mutation.target.id.includes('password')) {
                                    errorMsg = mutation.target.value ? 'wrong_email_or_wrong_password' : 'empty_password';
                                } else {
                                    errorMsg = 'unknown_error';
                                }
                                _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificAnalyticsErrorEvent('login', 'login', errorMsg);
                                    genericEventAlreadyFired = true;
                                }

                                inputSet.add(mutation.target.id);
                            }
                        }
                    }
                    observer.disconnect();
                };

                let observer = new MutationObserver(callback);
                observer.observe(targetLoginNode, config);
            }
        }

        if (document.querySelectorAll('form.loginAndAssociateOrder').length > 0) {
            let registrationStartFrom = document.querySelectorAll('form.loginAndAssociateOrder')[0];
            let submitButtonAnalytics = registrationStartFrom.querySelectorAll('button[type=submit]')[0];
            submitButtonAnalytics.addEventListener('click', function (e) {
                enableLoginAndAssociateAnalyticsObserver();
            });
        }
    }

    loginAndAssociateOrderWithCustomer () {
        const _self = this;
        $('form.loginAndAssociateOrderWithCustomer').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();

            $('form.loginAndAssociateOrderWithCustomer').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                        $('loginAndAssociateOrderWithCustomer.login').trigger('login:error', data);
                        $('#login-form-password').val('');
                        _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', 'wrong_email_or_wrong_password');
                        _self.fireSpecificAnalyticsErrorEvent('login', 'login', 'wrong_email_or_wrong_password');
                    } else {
                        // order association request
                        var associationForm = $('form.orderAssociation');
                        var url = associationForm.attr('action');
                        $('body').trigger('customer:login', {
                            'type': 'login',
                            'data': data
                        });
                        $.ajax({
                            url: url,
                            type: "post",
                            dataType: "json",
                            data: associationForm.serialize(),
                            success: function (data) {
                                if (data.success) {
                                    $('.loginContainer').remove();
                                    if (RegistrationHelper.isLoyaltyAvailable()) {
                                        $('.js-unified-modal-loyalty-registration').val('user-is-logged');
                                        $('.js-unified-modal-loyalty-registration').trigger('click');
                                    } else {
                                        $('.loyaltyContainer').removeClass('hidden');
                                    }
                                    $('.analytics.helperData').data('user-id', data.hkCustomerId);
                                } else {
                                    // order can't be associated
                                    $('#login').prop('disabled',true);
                                    $('.login-form-error').addClass('hidden');
                                    $('#orderAssociationError').removeClass('hidden');
                                }
                            },
                            error: function (data) {
                                $('#login').prop('disabled',true);
                                $('.login-form-error').addClass('hidden');
                                $('#orderAssociationError').removeClass('hidden');
                                $('loginAndAssociateOrderWithCustomer.login').trigger('login:error', data);
                            }
                        });
                    }
                },
                error: function (data) {
                    $('body').trigger('customer:login', {
                        'type': 'login',
                        'data': ['unknown_error']
                    });
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('loginAndAssociateOrderWithCustomer.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });

        function enableCustomerLoginAndAssociateAnalyticsObserver () {
            let targetLoginNode = $('form.loginAndAssociateOrderWithCustomer').get(0);
            if (targetLoginNode) {
                let config = { attributes: true, childList: true, subtree: true };
                let callback = function (mutationsList, observer) {
                    let inputSet = new Set();
                    let genericEventAlreadyFired = false;
                    for (let index = 0; index < mutationsList.length; index++) {
                        let mutation = mutationsList[index];
                        if (mutation.type === 'attributes' &&
                            mutation.target.nodeName === 'INPUT' &&
                            mutation.attributeName === 'class' &&
                            mutation.target.classList.contains('is-invalid-input')) {
                            if (!inputSet.has(mutation.target.id)) {
                                let errorMsg = 'unknown_error';
                                if (mutation.target.id.includes('email')) {
                                    errorMsg = mutation.target.value ? 'email_already_registered_in_existing_account' : 'empty_field_or_invalid_email';
                                } else if (mutation.target.id.includes('password')) {
                                    errorMsg = mutation.target.value ? 'wrong_email_or_wrong_password' : 'empty_password';
                                } else {
                                    errorMsg = 'unknown_error';
                                }
                                _self.fireGenericAnalyticsErrorEvent('login', 'step1_login', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificAnalyticsErrorEvent('login', 'login', errorMsg);
                                    genericEventAlreadyFired = true;
                                }

                                inputSet.add(mutation.target.id);
                            }
                        }
                    }
                    observer.disconnect();
                };

                let observer = new MutationObserver(callback);
                observer.observe(targetLoginNode, config);
            }
        }

        if (document.querySelectorAll('form.loginAndAssociateOrderWithCustomer').length > 0) {
            let registrationStartFrom = document.querySelectorAll('form.loginAndAssociateOrderWithCustomer')[0];
            let submitButtonAnalytics = registrationStartFrom.querySelectorAll('button[type=submit]')[0];
            submitButtonAnalytics.addEventListener('click', function (e) {
                enableCustomerLoginAndAssociateAnalyticsObserver();
            });
        }
    }

    registerAndAssociateOrderForm () {
        const _self = this;
        $('form.registrationAndOrderAssociation').submit(function (e) {
            $('#registration-error-message').addClass('hidden');
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('#registration-error-message').removeClass('hidden');
                        _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', 'email_or_number_already_registered');
                    } else {
                        $('body').trigger('customer:registerFirst', {
                            'type': 'registration',
                            'data': data
                        });
                        var redirectUrl = $('#loginPageURL').data('url') || data.redirectUrl;
                        location.href = redirectUrl;
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                    $('#registration-error-message').removeClass('hidden');
                }
            });
            return false;
        });
    }

    prepareLoyaltySubscriptionForm () {
        $('button.prepareLoyaltySubscription').click(function (e) {
            $('#registration-error-message').addClass('hidden');
            var form = $('form.prepareLoyaltySubscription');
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('#registration-error-message').removeClass('hidden');
                    } else {
                        $('body').trigger('analytics:prepareLoyaltySubscription');
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                    $('#registration-error-message').removeClass('hidden');
                }
            });
            return false;
        });
    }

    accountRegisterForm () {
        const _self = this;
        if ($('#login-warn-label').text().length > 2) {
            $('#reg-phone-error').text($('#login-warn-label').text())
                .addClass('is-invalid success-block')
                .removeClass('color-alert hidden')
                .siblings('.invalid-feedback')
                .show();
        }

        $('form.registrationStart').ready(function () {
            if ($('#login-warn-label').text().length > 2) {
                $('#reg-mail-error').html($('#login-warn-label').text())
                    .addClass('is-invalid')
                    .siblings('.invalid-feedback')
                    // .html()
                    .show();
                $('#reg-mail-error').addClass('success-block');
                $('#reg-mail-error').removeClass('color-alert');
            }
        });

        $('body').on('change', '.loyaltyFlag', function (e) {
            var isChecked = $(e.currentTarget).prop('checked');
            if (isChecked) {
                $('.dob').removeClass('hidden');
                $('.opposition').removeClass('hidden');
                $('.warning-card-override').removeClass('hidden');
                $('.warning-card-override').addClass('success-block');
                $('.dob').prop('required', true);
                $('.button-register-final').data('loyalty-check', true);

                if (!$('.popover-loyalty-member-tez').hasClass('hidden')) {
                    toggleLoyaltyPopover(false);
                }
            } else {
                $('.dob').addClass('hidden');
                $('.opposition').addClass('hidden');
                $('.warning-card-override').addClass('hidden');
                $('.warning-card-override').removeClass('success-block');
                $('.dob').removeAttr('required');
                $('.button-register-final').data('loyalty-check', false);
            }
        });

        function updateProfilingToggleState($container) {
            const $marketingToggle = $container.find('.newspromotion');
            const $profilingToggle = $container.find('.personalizednews');
            if (!$profilingToggle.length) return;

            const $profilingContainer = $profilingToggle.closest('.form-group').find('.add-to-email-list-yes');
            const isMarketingChecked = $marketingToggle.is(':checked');
            const isBrandTezenis = $container.data('brand') === 'TEZENIS';

            let isProfilingDisabled;

            if (isBrandTezenis) {
                isProfilingDisabled = !isMarketingChecked;
            } else {
                isProfilingDisabled = !isMarketingChecked || ($profilingToggle.data('initial-checked') === false);
            }

            $profilingToggle.prop('disabled', isProfilingDisabled);
            $profilingContainer.toggleClass('disabled', isProfilingDisabled);

            if (!isMarketingChecked) {
                $profilingToggle.prop('checked', false);
            }
        }

        $('.accordion-settings, .policy-promotion-payment').each(function () {
            const $container = $(this);
            const $profilingToggle = $container.find('.personalizednews');
            if ($profilingToggle.length) {
                $profilingToggle.data('initial-checked', $profilingToggle.is(':checked'));
            }
            updateProfilingToggleState($container);
        });

        $('body').on('change', 'input.newspromotion', function (e) {
            const $container = $(e.target).closest('.accordion-settings, .policy-promotion-payment');
            updateProfilingToggleState($container);

            initNewsletterAnalyticsBrands();
            const brandName = $(e.currentTarget).attr('name').split('-')[1];
            if (window.newsletterPreferenceBrands.indexOf(brandName) === -1) {
                window.newsletterPreferenceBrands.push(brandName);
            }
            $('.activable-after-change').prop('disabled', false);
        });

        $('input.personalizednews').on('change', (e) => {
            initNewsletterAnalyticsBrands();
            let brandName = $(e.currentTarget).attr('name').split('-')[1];
            if (window.newsletterPreferenceBrands.indexOf(brandName) === -1) {
                window.newsletterPreferenceBrands.push(brandName);
            }
        });

        $('body').on('click', '.save-button-newsletter-pref', function (e) {
            $('body').trigger('customer:newsletterPreferencesSave', {
                'direktMarketingAgreement': $('input[name=directMarketingAgreement-TEZENIS]').is(':checked'),
                'profilingAgreement': $('input[name=profilingAgreement-TEZENIS]').is(':checked'),
                'brands': window.newsletterPreferenceBrands,
            });
        });

        $('body').on('change', 'input.newspromotion, input.personalizednews', function (e) {
            $(e.currentTarget).val($(e.currentTarget).prop('checked'));
            $('.activable-after-change').prop('disabled', false);
        });

        $('body').on('change', '.toggle-loyalty-form', function (e) {
            $('.disabledForm').prop('disabled', !$(e.currentTarget).prop('checked'));
        });

        $(document).on('click', '.sendNewOtp', function (e) {
            e.preventDefault();
            $('#registration-form-phone-confirm').val('');
            $('#registration-form-phone-confirm').attr('required', false);
            $('#reg-phone-otp-error').addClass('hide');
            $('form.registration').submit();
        });

        $('form.registration').on('submit', function (e) {
            e.preventDefault();

            // Check if loyalty flag is checked during registration step 3. If not show alert
            if (!checkLoyaltyFlag()) {
                return;
            }

            var form = $(this);
            var url = form.attr('action');
            FormHelpers.clearPreviousErrors(form);
            $('form.registration').trigger('login:register', e);
            var dataForm = form.serialize();
            if (RegistrationHelper.isRegistrationModalFlow()) {
                dataForm += '&isModalFlow=true';
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: dataForm,
                success: function (data) {
                    $('.save-button-newsletter-pref').prop('disabled', true);
                    form.spinner().stop();
                    if (data.isUpdatePreferences) {
                        $('body').trigger('customer:preferences', data.success);
                        _self.hideDeselectedAccordions();
                        $(window).scrollTop(0);
                        return;
                    }
                    if (!data.success) {
                        if (data.cardError) {
                            $('.card-error').html(data.error);
                            $('.card-error').removeClass('hide');
                            $('.login-form-error-block').html('');
                            $('#loyalty-form-cardCode, #loyalty-form-cardPin').addClass('is-invalid-input');
                            $('.disabledForm').prop('disabled', true);
                        } else if (data.phone2Opt) {
                            $('.registerPhoneButton').prop('disabled', true);
                            $('.registration-phone-confirm-block').addClass('2OptFlow');
                            $('.registration-phone-confirm-block').removeClass('hide');
                            $('#registration-form-phone-confirm').attr('required', true);
                            $('.login-form-error').html('').removeClass('login-form-error-block');
                            $('#reg-phone-error').addClass('hide');
                            if (data.error && data.error.length) {
                                $('#reg-phone-otp-error').html(data.error)
                                    .addClass('is-invalid')
                                    .show();
                                $('#reg-phone-otp-error').addClass('color-alert');
                                $('#reg-phone-otp-error').addClass('login-form-error-block');
                                $('#reg-phone-otp-error').removeClass('success-block');
                                $('#reg-phone-otp-error').removeClass('hide');
                                $('.sendNewOtp').addClass('color-alert');
                            }
                        } else {
                            $('.card-error').addClass('hide');
                            FormHelpers.init(form, data);
                            let errorMsg = 'email_or_number_already_registered';
                            if (data.fields) {
                                FormHelpers.loadFormErrors(form, data.fields);
                                if ($('.birthdate-error')) {
                                    $('.birthdate-error').html(data.birthDateError);
                                    errorMsg = 'wrong_date_of_birth';
                                }
                            }
                            if ($('.page').data('action') === 'Account-RegistrationPhoneShow') {
                                errorMsg = 'inserted_number_different_from_stored_number';
                            }
                            if ($('.page').data('action') === 'Account-RegistrationFormShow') {
                                if ($('#loyaltyRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step4_personal_data', errorMsg);
                                    _self.fireSpecificEventModeAnalyticsErrorEvent(
                                        'registrationLoyaltyStep4', 'loyalty_card', errorMsg, 'phone');
                                } else if ($('#socialRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', errorMsg);
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialThird', 'social_registration', errorMsg);
                                } else {
                                    _self.fireGenericAnalyticsErrorEvent('registration', 'step3_personal_data', errorMsg);
                                    _self.fireSpecificAnalyticsErrorEvent('registerThird', 'registration', errorMsg);
                                }
                            } else {
                                if ($('#loyaltyRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step3_phone', errorMsg);
                                    _self.fireSpecificEventModeAnalyticsErrorEvent(
                                        'registrationLoyaltyStep3', 'loyalty_card', errorMsg, 'phone');
                                } else if ($('#socialRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('social_registration', 'step2_phone', errorMsg);
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialSecond', 'social_registration', errorMsg);
                                } else {
                                    _self.fireGenericAnalyticsErrorEvent('registration', 'step2_phone', errorMsg);
                                    _self.fireSpecificAnalyticsErrorEvent('registerSecond', 'registration', errorMsg);
                                }
                            }
                        }
                        if ($('#login-error-label').text() && !data.phone2Opt) {
                            $('#reg-phone-error').html(data.error)
                                .addClass('is-invalid')
                                .siblings('.invalid-feedback')
                                .show();
                            $('#reg-phone-error').addClass('color-alert');
                            $('#reg-phone-error').addClass('login-form-error-block');
                            $('#reg-phone-error').removeClass('success-block');
                        }
                    } else {
                        if ($(e.currentTarget).hasClass('registration-step-final')) {
                            let rememberMe = $('.remember-me-container input#rememberMeTwo').is(':checked');
                            let analyticsMode = 'only_registration';
                            if (data.error) delete data.error;
                            if (data.loyaltySubscriptionRules) {
                                analyticsMode = 'profile_loyalty';
                                $('body').trigger('customer:registerLoyalty', {
                                    'analyticsMode': analyticsMode
                                });
                            }
                            data.type_reg = analyticsMode;
                            if ($('#socialRegistration').length > 0) {
                                $('body').trigger('customer:registerSocialThird', {
                                    'analyticsMode': analyticsMode,
                                    rememberMe
                                });
                            } else {
                                $('body').trigger('customer:registerThird', {
                                    'analyticsMode': analyticsMode,
                                    rememberMe
                                });
                            }
                        } else if ($(e.currentTarget).hasClass('registration-loyalty')) {
                            $('body').trigger('customer:registerLoyalty', {
                                'analyticsMode': 'only_loyalty'
                            });
                        } else if ($('#socialRegistration').length > 0) {
                            $('body').trigger('customer:registerSocialSecond', {'type': 'social_registration'});
                        } else {
                            $('body').trigger('customer:registerSecond', {'type': 'registration'});
                        }
                        if (RegistrationHelper.isRegistrationModalFlow()) {
                            var nextStep = $(e.currentTarget).hasClass('registration-step-final') ? 'waiting-room' : 'personal-info';
                            var phone = $('#registration-form-phone').val();
                            RegistrationHelper.fillPhoneText(phone);
                            RegistrationHelper.moveToNextStep(nextStep);

                            if (nextStep === 'personal-info') {
                                $.ajax({
                                    url: data.redirectUrl,
                                    type: 'get',
                                    dataType: 'json',
                                    data: dataForm,
                                    success: function (data) {
                                        RegistrationHelper.fieldsFormPrefill(data);
                                    },
                                    error: function (err) {
                                        if (err.responseJSON) {
                                            $('#login-error-label').text(err.responseJSON.message).removeClass('hidden');
                                        } else {
                                            $('#login-error-label').text(err.statusText).removeClass('hidden');
                                        }
                                    }
                                });
                            }
                        } else if (RegistrationHelper.isRegistrationLoyaltyModalFlow()) {
                            $('#registrationModal-box').attr('data-registration-modal-stage', 'loyalty-thankyou-page');
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (data) {
                    if ($('#login-error-label').length > 0) {
                        _self.fireGenericAnalyticsErrorEvent('registration', 'step2_phone', 'generic_error');
                        _self.fireSpecificAnalyticsErrorEvent('registerSecond', 'registration', 'generic_error');
                    } else if ($(e.currentTarget).hasClass('registration-loyalty')) {
                        _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step3_phone', 'generic_error');
                        _self.fireSpecificAnalyticsErrorEvent('registerSecond', 'loyalty_card', 'generic_error');
                    } else if ($('#socialRegistration').length > 0) {
                        _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', 'generic_error');
                        $('body').trigger('customer:registerSocialThird', {
                            'analyticsMode': 'only_registration',
                            'data': {
                                'error': ['generic_error']
                            }
                        });
                    } else {
                        _self.fireGenericAnalyticsErrorEvent('register', 'step3_personal_data', 'generic_error');
                        $('body').trigger('customer:registerThird', {
                            'analyticsMode': 'only_registration',
                            'data': {
                                'error': ['generic_error']
                            }
                        });
                    }
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    }
                    form.spinner().stop();
                }
            });
            return false;
        });

        $('form.registrationStart').on('submit', function (e) {
            e.preventDefault();

            var form = $(this);
            var url = form.attr('action');
            FormHelpers.clearPreviousErrors(form);
            $('form.registration').trigger('login:register', e);

            let stateObj = {
                foo: form.data('back-link-obj')
            };
            history.pushState(stateObj, '', form.data('back-link'));

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);
                        }
                        if (data.bluColor) {
                            RegistrationHelper.closeRegistrationOpenLoginInit();
                            $('.already-registered-1').removeClass('login-form-error-block');
                            $('.already-registered-1').removeClass('color-alert');
                            $('.already-registered-1').addClass('is-invalid');
                            $('.already-registered-1').addClass('success-block');
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step2_email', 'email_or_number_already_registered');
                                _self.fireSpecificEventModeAnalyticsErrorEvent(
                                    'registrationLoyaltyStep2', 'loyalty_card', 'email_or_number_already_registered', 'email');
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step1_email', 'email_or_number_already_registered');
                                _self.fireSpecificAnalyticsErrorEvent('registerSocialFirst', 'social_registration', 'email_or_number_already_registered');
                            } else {
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step1_email', 'email_or_number_already_registered');
                                _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', 'email_or_number_already_registered');
                            }
                        } else {
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step2_email', 'email_or_number_already_registered');
                                _self.fireSpecificEventModeAnalyticsErrorEvent(
                                    'registrationLoyaltyStep2', 'loyalty_card', 'email_or_number_already_registered', 'email');
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step1_email', 'email_or_number_already_registered');
                                _self.fireSpecificAnalyticsErrorEvent('registerSocialFirst', 'social_registration', 'email_or_number_already_registered');
                            } else {
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step1_email', 'email_or_number_already_registered');
                                _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', 'email_or_number_already_registered');
                            }
                        }
                        if (data.socialRegistrationError) {
                            $('#reg-mail-error').addClass('color-alert');
                            $('#reg-mail-error').addClass('login-form-error-block');
                            $('#reg-mail-error').removeClass('success-block');
                        }
                    } else {
                        if (data.error) delete data.error;
                        if ($('#socialRegistration').length > 0) {
                            $('body').trigger('customer:registerSocialFirst', {
                                'type': 'social_registration',
                                'data': data
                            });
                        } else {
                            $('body').trigger('customer:registerFirst', {
                                'type': 'registration',
                                'data': data
                            });
                        }
                        if (RegistrationHelper.isRegistrationModalFlow()) {
                            var email = data.registrationFormObj.emailFromForm;
                            RegistrationHelper.fillEmailText(email);
                            RegistrationHelper.fillEmailValue(email);
                            RegistrationHelper.moveToNextStep('phone');
                            if (data.hiddenPhonePlaceholder) {
                                RegistrationHelper.handleExistingAccount(data);
                            }
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (data) {
                    if ($('.loyalty-step1').length > 0) {
                        _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step1', 'generic_error');
                    } else {
                        _self.fireGenericAnalyticsErrorEvent('registration', 'step1', 'generic_error');
                        _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', 'generic_error');
                    }
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    }
                    form.spinner().stop();
                }
            });
            return false;
        });

        const config = { attributes: true, childList: true, subtree: true };
        function enableRegistrationStartAnalyticsObserver () {
            let targetRegistrationStep1Node = $('form.registrationStart').get(0);
            let registrationStep1Callback = function (mutationsList, observer) {
                let inputSet = new Set();
                let genericEventAlreadyFired = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'INPUT' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!inputSet.has(mutation.target.id)) {
                            let errorMsg = 'unknown_error';
                            if (mutation.target.id.includes('email')) {
                                errorMsg = 'empty_or_invalid_email';
                            } else {
                                errorMsg = 'unknown_error';
                            }
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step2_email', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificEventModeAnalyticsErrorEvent('registrationLoyaltyStep2', 'loyalty_card', errorMsg, 'email');
                                    genericEventAlreadyFired = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step1_email', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerSocialFirst', 'social_registration', errorMsg);
                                    genericEventAlreadyFired = true;
                                }
                            } else {
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step1_email', errorMsg);
                                if (!genericEventAlreadyFired) {
                                    _self.fireSpecificAnalyticsErrorEvent('registerFirst', 'registration', errorMsg);
                                    genericEventAlreadyFired = true;
                                }
                            }

                            inputSet.add(mutation.target.id);
                        }
                    }
                }
                registrationStep1Observer.disconnect();
            };
            let registrationStep1Observer = new MutationObserver(registrationStep1Callback);
            registrationStep1Observer.observe(targetRegistrationStep1Node, config);
        }

        function enablePhoneRegistrationAnalyticsObserver () {
            var generalTrackingEventAlreadyTriggered = false;
            let targetRegistrationNode = $('form.registration').get(0);
            if (targetRegistrationNode) {
                const registrationCallback = function (mutationsList, observer) {
                    let inputSet = new Set();
                    let isGenericEventFiredOnce = false;
                    for (let index = 0; index < mutationsList.length; index++) {
                        let mutation = mutationsList[index];
                        if (mutation.type === 'attributes' &&
                            mutation.target.nodeName === 'INPUT' &&
                            mutation.attributeName === 'class' &&
                            mutation.target.classList.contains('is-invalid-input')) {
                            if (!inputSet.has(mutation.target.id)) {
                                let errorMsg = 'unknown_error';
                                if (mutation.target.id.includes('fname')) {
                                    errorMsg = mutation.target.value ? 'wrong_firstname' : 'empty_firstname';
                                } else if (mutation.target.id.includes('lname')) {
                                    errorMsg = mutation.target.value ? 'wrong_lastname' : 'empty_lastname';
                                } else if (mutation.target.id.includes('email')) {
                                    errorMsg = 'empty_or_invalid_email';
                                } else if (mutation.target.id.includes('phone')) {
                                    errorMsg = 'empty_or_invalid_phone_number';
                                } else if (mutation.target.id.includes('prefix')) {
                                    errorMsg = 'empty_or_invalid_prefix_number';
                                } else if (mutation.target.id.includes('password-confirm')) {
                                    errorMsg = mutation.target.value ? 'mismatch_password' : 'empty_password';
                                } else if (mutation.target.id.includes('password')) {
                                    errorMsg = mutation.target.value ? 'wrong_password' : 'empty_password';
                                } else {
                                    errorMsg = 'unknown_error';
                                }

                                if ($('#loyaltyRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step3_personal_data', errorMsg);
                                    if (!generalTrackingEventAlreadyTriggered) {
                                        _self.fireSpecificEventModeAnalyticsErrorEvent('registrationLoyaltyStep3', 'loyalty_card', errorMsg, 'phone');
                                        generalTrackingEventAlreadyTriggered = true;
                                    }
                                } else if ($('#socialRegistration').length > 0) {
                                    _self.fireGenericAnalyticsErrorEvent('social_registration', 'step2_phone', errorMsg);
                                    if (!generalTrackingEventAlreadyTriggered) {
                                        _self.fireSpecificAnalyticsErrorEvent('registerSocialSecond', 'social_registration', errorMsg);
                                        generalTrackingEventAlreadyTriggered = true;
                                    }
                                } else {
                                    _self.fireGenericAnalyticsErrorEvent('registration', 'step2_phone', errorMsg);
                                    if (!generalTrackingEventAlreadyTriggered) {
                                        _self.fireSpecificAnalyticsErrorEvent('registerSecond', 'registration', errorMsg);
                                        generalTrackingEventAlreadyTriggered = true;
                                    }
                                }

                                inputSet.add(mutation.target.id);
                            }
                        }
                    }
                    registrationObserver.disconnect();
                };

                let registrationObserver = new MutationObserver(registrationCallback);
                registrationObserver.observe(targetRegistrationNode, config);
            }
        }

        function enableFinalRegistrationAnalyticsObservers () {
            var generalTrackingEventAlreadyTriggered = false;
            let targetRegistrationNode = $('form.registration').get(0);
            let registrationCallback = function (mutationsList, observer) {
                let inputSet = new Set();
                for (let index = 0; index < mutationsList.length; index++) {
                    if (index === 0) generalTrackingEventAlreadyTriggered = false;
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'INPUT' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!inputSet.has(mutation.target.id)) {
                            let errorMsg = 'unknown_error';
                            if (mutation.target.id.includes('fname')) {
                                errorMsg = mutation.target.value ? 'wrong_firstname' : 'empty_firstname';
                            } else if (mutation.target.id.includes('lname')) {
                                errorMsg = mutation.target.value ? 'wrong_lastname' : 'empty_lastname';
                            } else if (mutation.target.id.includes('password-confirm')) {
                                errorMsg = mutation.target.value ? 'mismatch_password' : 'empty_password';
                            } else if (mutation.target.id.includes('password')) {
                                errorMsg = mutation.target.value ? 'wrong_password' : 'empty_password';
                            } else if (mutation.target.id.includes('dpReg')) {
                                errorMsg = mutation.target.value ? 'wrong_date_of_birth' : 'empty_date_of_birth';
                            }

                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step4_personal_data', errorMsg);
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registrationLoyaltyStep4', 'loyalty_card', errorMsg);
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', errorMsg);
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerSocialThird', {
                                        'analyticsMode': 'only_registration',
                                        'data': {
                                            'error': [errorMsg]
                                        }
                                    });
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else {
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step3_personal_data', errorMsg);
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerThird', {
                                        'analyticsMode': 'only_registration',
                                        'data': {
                                            'error': [errorMsg]
                                        }
                                    });
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            }
                            inputSet.add(mutation.target.id);
                        }
                    }
                }
                registrationObserver.disconnect();
            };
            let registrationObserver = new MutationObserver(registrationCallback);
            registrationObserver.observe(targetRegistrationNode, config);

            let targetLoyaltyFlagsNode = $('#loyalty-yes').parent().parent().get(0);
            let loyaltyFlagsCallback = function (mutationsList, observer) {
                let alreadyTriggeredOnce = false;
                for (let index = 0; index < mutationsList.length; index++) {
                    let mutation = mutationsList[index];
                    if (mutation.type === 'attributes' &&
                        mutation.target.nodeName === 'LABEL' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('is-invalid-input')) {
                        if (!alreadyTriggeredOnce) {
                            if ($('#loyaltyRegistration').length > 0) {
                                _self.fireGenericAnalyticsErrorEvent('loyalty_card', 'step4_personal_data', 'empty_loyalty_flag');
                                if (!generalTrackingEventAlreadyTriggered) {
                                    _self.fireSpecificAnalyticsErrorEvent('registrationLoyaltyStep4', 'loyalty_card', 'empty_loyalty_flag');
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                            } else if ($('#socialRegistration').length > 0) {
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerSocialThird', {'status': 'error'});
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                                _self.fireGenericAnalyticsErrorEvent('social_registration', 'step3_personal_data', 'empty_loyalty_flag');
                            } else {
                                if (!generalTrackingEventAlreadyTriggered) {
                                    $('body').trigger('customer:registerThird', {'status': 'error'});
                                    generalTrackingEventAlreadyTriggered = true;
                                }
                                _self.fireGenericAnalyticsErrorEvent('registration', 'step3_personal_data', 'empty_loyalty_flag');
                            }
                            alreadyTriggeredOnce = true;
                        }
                    }
                }
                loyaltyFlagsObserver.disconnect();
            };
            let loyaltyFlagsObserver = new MutationObserver(loyaltyFlagsCallback);
            if (targetLoyaltyFlagsNode) {
                loyaltyFlagsObserver.observe(targetLoyaltyFlagsNode, config);
            }
        }

        if (document.querySelectorAll('form.registrationStart').length > 0) {
            let registrationStartFrom = document.querySelectorAll('form.registrationStart')[0];
            let submitButtonAnalytics = registrationStartFrom.querySelectorAll('button[type=submit]')[0];
            submitButtonAnalytics.addEventListener('click', function (e) {
                enableRegistrationStartAnalyticsObserver();
            });
        }

        if ((window.location.pathname.includes('phone') && window.location.pathname.includes('register')) ||
            document.getElementById('registration-form-phone')) {
            let allForms = document.getElementsByTagName('FORM');
            for (let localIndex = 0; localIndex < allForms.length; localIndex++) {
                if (allForms[localIndex].classList.contains('registration')) {
                    try {
                        let registrationFormAnalytics = allForms[localIndex];
                        let submitButtonAnalytics = registrationFormAnalytics.querySelectorAll('button[type=submit]')[0];
                        submitButtonAnalytics.addEventListener('click', function (e) {
                            enablePhoneRegistrationAnalyticsObserver();
                        });
                    } catch (e) {}
                }
            }
        }

        if (document.getElementsByClassName('button-register-final')[0]) {
            document.getElementsByClassName('button-register-final')[0].addEventListener('click', function (e) {
                enableFinalRegistrationAnalyticsObservers();
            });
        }

        /* $('#registration-form-phone, #registration-form-prefix').on('change', (e) => {
            if ($('.registration-phone-confirm-block').hasClass('2OptFlow')
                && !$('.registration-phone-confirm-block').hasClass('hide')) {
                $('.registerPhoneButton').prop('disabled', false);
                $('#registration-form-phone-confirm').attr('required', false);
                $('.registration-phone-confirm-block').addClass('hide');
                $('#registration-form-phone-confirm').val('');
                $('.login-form-error').html('').removeClass('login-form-error-block');
                $('#reg-phone-error').removeClass('hide');
            }
        }); */
    }

    forgotPassword (modalToClose = false) {
        const self = this;
        $('#password-reset, .password-reset').on('click', function (e) {
            e.preventDefault();

            if (Foundation.MediaQuery.atLeast('medium')) {
                if (modalToClose) {
                    modalToClose.close();
                    modalToClose.destroy();
                }
            }

            const htmlContent = $($(this).data('target')).clone().html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false, ['resetPwdModal', 'layer-password-modal']);
            $(modal.modalBox).addClass('rightModalAttribute');

            Plugins.init();
            modal.open();
            self.resetPasswordForm();

            $(modal.modalBox).find('.request-password-title').removeClass('hidden');
            $(modal.modalBox).find('.social-request-password-title').addClass('hidden');
            $(modal.modalBox).find('.request-password-body-description').removeClass('hidden');
            $(modal.modalBox).find('.social-request-password-body-description').addClass('hidden');
            $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
                if (modalToClose) {
                    modalToClose.close();
                    modalToClose.destroy();
                }
            });
            $(modal.modalBox).on('click', '.back-to-login', (e) => {
                e.preventDefault();
                modal.close();
                modal.destroy();
            });
        });
    };

    resetPasswordForm () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            FormHelpers.clearPreviousErrors(form);
            var url = form.attr('action');
            $.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);
                        }
                    } else {
                        form.closest('.modal-content').find('.request-password-title').text(data.receivedMsgHeading);
                        if (!Foundation.MediaQuery.atLeast('large') && data.receivedMsgHeadingMobile) {
                            $('.social-request-password-title').text(data.receivedMsgHeadingMobile);
                        } else {
                            $('.social-request-password-title').text(data.receivedMsgHeading);
                        }
                        $('.request-password-body', form).empty()
                            .append('<p class="font-normal">' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton', form).hide();
                            $('#loginButton', form)
                                .removeClass('hidden')
                                .attr('data-dismiss', 'modal')
                                .addClass('btn-close');
                        } else {
                            $('.send-email-btn', form).empty()
                                .html('<a href="' +
                                    data.returnUrl +
                                    '" class="button">' +
                                    data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    };

    checkoutLogin () {
        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    form.spinner().stop();
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                }
            });
            return false;
        });
    };

    checkoutRegisterForm () {
        $('form.checkout-registration').submit(e => {
            e.preventDefault();
            var form = $(e.currentTarget);
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: data => {
                    form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init(form, data);
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: err => {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    form.spinner().stop();
                }
            });
            return false;
        });
    };

    editProfileForm () {
        const checkPreferencesEnabled = () => {
            $('#promotions-1').prop('required', true);
            $('#profiling-1').prop('required', true);
            $('.promotions-1').on('change', (e) => {
                if (e.target.id === 'promotions-1' && e.target.checked) {
                    if (e.target.value != null && e.target.value) {
                        $('#profiling-1').prop('disabled', false);
                        $('#profiling-2').prop('disabled', false);
                    } else {
                        $('#promotions-1').prop('required', false);
                        $('#profiling-1').prop('required', false);
                    }
                } else {
                    $('#profiling-1').prop('disabled', true);
                    $('#profiling-2').prop('disabled', true);
                    $('#profiling-1').prop('checked', false);
                    $('#profiling-2').prop('checked', false);
                    $('#profiling-1').prop('required', false);
                }
            });
        };

        checkPreferencesEnabled();
        $('first-yes').on('change', checkPreferencesEnabled);

        $('body').on('submit', 'form.edit-profile-form', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $.spinner().start();
            $('form.edit-profile-form').trigger('profile:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init($form, data);
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    };

    editPasswordForm () {
        $('body').on('submit', 'form.change-password-form', function (e) {
            e.preventDefault();
            var form = $(this);
            FormHelpers.clearPreviousErrors(form);
            var url = form.attr('action');
            $.spinner().start();
            $('form.change-password-form').trigger('password:edit', e);

            $('.alert-password-changed, .alert-password-error').addClass('hidden');
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);
                        }
                    } else if ($('.page').data('action') === 'Account-Profile') {
                        // MyAccount edit password
                        location.href = data.redirectUrl;
                    } else {
                        // Forgot password flow
                        $('.alert-password-changed').removeClass('hidden');
                        $('.btn-new-password-confirm').addClass('hidden');
                        $('.btn-new-password-done').removeClass('hidden');
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                    $('.alert-password-error').removeClass('hidden');
                }
            });
            return false;
        });
    };

     hideDeselectedAccordions() {
        $('.accordion-settings').each(function () {
            var $accordion = $(this);
            var $toggle = $accordion.find('.newspromotion');
            if (!$toggle.is(':checked')) {
                $accordion.closest('li.accordion-item').hide();
            }
        });

        var $newsletterContainer = $('.newsletter-container');
        if ($newsletterContainer.find('li.accordion-item:visible').length === 0) {
            $newsletterContainer.hide();
        }
    }

    policyPrivacyFlag () {
        $('body').on('submit', 'form.privacy-preferences', function (e) {
            $('.success-block-save').addClass('hidden');
            $('.error-block-save').addClass('hidden');
            $('form.registration').trigger('submit');
        });

        $('body').on('customer:preferences', function (e, success) {
            var $element = success ? $('.success-block-save') : $('.error-block-save');

            $element.fadeIn().removeClass('hidden').delay(5000).fadeOut(function () {
                $(this).addClass('hidden');
            });
        });
    }

    feedbackMessages () {
        if (!$('.js-feedback-message').length) {
            return;
        }

        if (window.location.href.indexOf('ju') > -1 || window.location.href.indexOf('jr') > -1) {
            var cleanUri = location.protocol + '//' + location.host + location.pathname;
            window.history.replaceState({}, document.title, cleanUri);
        }

        $('.js-feedback-message').delay(5000).fadeOut(function () {
            $(this).addClass('hidden');
        });
    }

    editEmailForm () {
        /*
        var changeEmailForm = document.querySelector('form.change-email-form');
        if (changeEmailForm) {
            changeEmailForm.addEventListener('input', function () {
                if ($('#registration-form-email').val() === $('form.change-email-form').data('initial-value')) {
                    $('.activable-after-change-email').prop('disabled', true);
                } else {
                    $('.activable-after-change-email').prop('disabled', false);
                }
            });
        }
        */
        $('body').on('click', '.activable-after-change-email', function (e) {
            e.preventDefault();
            var $form3 = $('form.change-email-form');
            $.spinner().start();
            $('.js-change-email-error-msg').addClass('hidden');
            if (!$form3.parsley().validate()) {
                $.spinner().stop();
                return;
            }

            // PreSaveNewEmail
            var url = $form3.data('pre-action-url');
            if (!url) {
                $.spinner().stop();
                return;
            }

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form3.serialize(),
                success: function (data) {
                    $.spinner().stop();
                    if (!data.success) {
                        var errorChangeEmail = '';
                        if (data.herokuError) {
                            errorChangeEmail = data.errorMessage;
                        } else if (data.sfccError) {
                            errorChangeEmail = data.errorMessage;
                        // Russia
                        } else if (data.validDomainError) {
                            errorChangeEmail = data.errorMessage;
                        }
                        $('.js-change-email-error-msg').text(errorChangeEmail);
                        $('.js-change-email-error-msg').removeClass('hidden');
                        $('#registration-form-email').removeClass('is-valid-input');
                        $('#registration-form-email').addClass('is-invalid-input');
                    } else {
                        // Systems to update
                        $('.js-system-to-update').html(data.modalContent);

                        const htmlContent = $('#editEmailAddressModal').html();

                        const onChangeEmailPopupClose = () => {
                            // Redirect to the account page with info banner
                            if (!$('.js-confirmation-message-two').hasClass('hidden')) {
                                if ($('.js-confirmation-message-two').data('url-redirect')) {
                                    window.location.href = $('.js-confirmation-message-two').data('url-redirect');
                                }
                            }
                        };

                        // create and open confirmation modal
                        const modal = newModalFromString(htmlContent, false, [], null, onChangeEmailPopupClose);
                        modal.open();
                        $(modal.modalBox)
                            .find('.close')
                            .on('click', function (e) {
                                e.preventDefault();
                                modal.close();
                            });

                        $('[data-dismiss="modal"]').on('click', function (e) {
                            e.preventDefault();
                            modal.close();
                        });

                        $('body').on('click', '.edit-email-confirmation-btn', 'click', function (f) {
                            $.spinner().start();
                            var $form3 = $('form.change-email-form');
                            if (!$form3.parsley().validate()) {
                                $.spinner().stop();
                                return;
                            }
                            $.ajax({
                                url: $form3.attr('action'),
                                type: 'post',
                                dataType: 'json',
                                data: $form3.serialize(),
                                success: function (data) {
                                    if (data.success) {
                                        $('.js-confirmation-message-one').addClass('hidden');
                                        $('.js-confirmation-message-two').removeClass('hidden');
                                        $('.js-confirmation-message-two').data('url-redirect', data.redirectUrl);
                                    }
                                    // TODO: Redirect with error message to the Account-Profile
                                    $.spinner().stop();
                                },
                                error: function (err) {
                                    // modal.close();
                                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                                        window.location.href = err.responseJSON.redirectUrl;
                                    }
                                    $.spinner().stop();
                                }
                            });
                        });
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
        $('body').on('submit', 'form.change-email-form', function (e) {
            e.preventDefault();
            var form = $(this);
            FormHelpers.clearPreviousErrors(form);
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.fields) {
                            FormHelpers.loadFormErrors(form, data.fields);
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                }
            });
            return false;
        });

        $('body').on('submit', 'form.confirm-change-email-form', function (e) {
            e.preventDefault();
            $('.change-mail-form-error').empty().addClass('hidden');
            var form = $(this);
            FormHelpers.clearPreviousErrors(form);
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        if (data.errorMessage) {
                            $('.change-mail-form-error').html(data.errorMessage).removeClass('hidden');
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    form.spinner().stop();
                }
            });
            return false;
        });
    };

    resendActivationEmail () {
        $('body').on('click', '.resend-activation-email', function (e) {
            e.preventDefault();
            var url = $(e.currentTarget).attr('href');
            var email = $(e.currentTarget).data('email');
            const payload = {
                email: email
            };
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: payload,
                success: function (data) {
                    $.spinner().stop();
                    if (data.success) {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    $.spinner().stop();
                }
            });
        });
    };
   
    socialLoginHandler (fromLayer = false) {
        const _self = this;

        var processSocialLogin = function (e, data) {
            var loginResult = data && data.loginResult;
            // gigyaHandlerResult dispatches the same result both as native and as jQuery event:
            // process it only once (double AJAX call and double analytics events otherwise)
            if (!loginResult || loginResult === _self.lastSocialLoginResult) {
                return;
            }
            _self.lastSocialLoginResult = loginResult;

            var containerID = data.loginResult && data.loginResult.containerID;
            var url = containerID ? $('#' + containerID).data('url') : null;
            if (!url) {
                url = $('.socialLoginContainer').data('url');
                if ($('#loginGigya').length) {
                    url = $('#loginGigya.socialLoginContainer').data('url');
                }
            }
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data.loginResult.user,
                success: function (data) {
                    $.spinner().stop();
                    if (containerID && $('#' + containerID).closest('#unified-login-form').length) {
                        data.regFlowPosition = $('.js-unified-page-wrapper').length ? 'landing_page' : 'modal';
                    }
                    if (!data.success) {
                        if (data.sfccRegisteredUser) {
                            if ($('.js-link-access').length) {
                                $('.js-link-access').click();
                            }
                            $('.social-login-form-error').empty().html(data.error);
                            $('.social-login-form-error').removeClass('hidden');
                            
                            _self.fireGenericAnalyticsErrorEvent('social_registration', 'step1_email', 'email_or_number_already_registered');
                            $('body').trigger('customer:social_email_already_used', {
                                'type': 'email',
                                'socialName': data.socialName,
                                'errorMsg': 'email_already_registered'
                            });
                        } else if (data.errorMessage) {
                            if ($('.js-link-access').length) {
                                $('.js-link-access').click();
                            }
                            $('.social-login-form-error').empty().html(data.error);
                            $('.social-login-form-error').removeClass('hidden');
                            if (data.socialLogin) {
                                $('body').trigger('customer:socialLogin', data);
                                _self.fireGenericAnalyticsErrorEvent('social_login', 'step1_login', 'generic_error');
                            }
                        }
                    } else {
                        localStorage.setItem('socialFirstStepMail', '');
                        if (data.socialLogin) {
                            $('body').trigger('customer:socialLogin', data);
                        }

                        if (!data.socialLogin) {
                            $('body').trigger('unifiedRegistration:socialRegistration', data);
                            return;
                        }

                        if (fromLayer && data.socialLogin) {
                            location.reload();
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (data) {
                    $.spinner().stop();
                }
            });
        };

        $('body').off('socialLogin:handler.customer').on('socialLogin:handler.customer', processSocialLogin);

        if (_self.socialLoginNativeListener) {
            window.removeEventListener('socialLogin:nativeHandler', _self.socialLoginNativeListener);
        }
        _self.socialLoginNativeListener = function (event) {
            processSocialLogin(event, event.detail);
        };
        window.addEventListener('socialLogin:nativeHandler', _self.socialLoginNativeListener);
    };

    ratingAndReviewsTabsHandler () {
        $('body').on('click', '.product-review-container .product-review-category-item', function (e) {
            $('body').trigger('customer:ratingAndReviewsTabsAction', $(e.currentTarget).data('analytics-name'));
        });
    }
}

const customer = new Customer();
export default customer;
